import {
  Home,
  Settings,
  Heart,
  Mail,
  Dices,
  CalendarDays,
  Ghost,
  MessageCircle,
  MoreHorizontal,
  Moon,
  Sun,
  LogOut,
  X,
  Check,
  Plus,
  Trash2,
  HelpCircle,
  ChevronLeft,
  Send,
  ImagePlus,
  Lock,
  RotateCcw,
  Bell,
  BellOff,
  type LucideProps,
} from 'lucide-react';

const map: Record<string, React.ComponentType<LucideProps>> = {
  Home,
  Settings,
  Heart,
  Mail,
  Dices,
  CalendarDays,
  Ghost,
  MessageCircle,
  MoreHorizontal,
  Moon,
  Sun,
  LogOut,
  X,
  Check,
  Plus,
  Trash2,
  ChevronLeft,
  Send,
  ImagePlus,
  Lock,
  RotateCcw,
  Bell,
  BellOff,
};

/** lucide 아이콘을 문자열 키로 렌더(모듈 메타의 icon 필드용). */
export function Icon({ name, ...props }: { name: string } & LucideProps) {
  const C = map[name] ?? HelpCircle;
  return <C {...props} />;
}
